import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ReactiveFormsModule } from '@angular/forms';
import { LoadingComponent } from './utils/loading/loading.component';
import { LoadingService } from './utils/loading/loading.service';
import { NotificationBarModule } from 'ngx-notification-bar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SolicitudOfertasModule } from './pages/solicitud-ofertas/solicitud-ofertas.module';
import { OfertaProductosModule } from './pages/oferta-productos/oferta-productos.module';
import { ContratacionesComponent } from './pages/contrataciones/contrataciones.component';
import { MainPageAcordarComponent } from './pages/main-page-acordar/main-page-acordar.component';
import { registerLocaleData } from '@angular/common';
import locale from '@angular/common/locales/es-AR';
import { PipeModule } from './pipes/pipe.module';
import { ErrorInterceptor } from './interceptor/http-interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
registerLocaleData(locale);

@NgModule({
	declarations: [ AppComponent, MainPageAcordarComponent, LoadingComponent, ContratacionesComponent ],
	imports: [
		BrowserModule,
		AppRoutingModule,
		ReactiveFormsModule,
		NotificationBarModule,
		BrowserAnimationsModule,
		SolicitudOfertasModule,
		OfertaProductosModule,
		PipeModule
	],
	providers: [
		LoadingService,
		{ provide: LOCALE_ID, useValue: 'es_AR' },
		{
			provide: HTTP_INTERCEPTORS,
			useClass: ErrorInterceptor,
			multi: true
		}
	],
	bootstrap: [ AppComponent ]
})
export class AppModule {}
